export const FETCH_NOTIFICATION_LIST = {
  LOADING: 'fetchNotificationListLoading',
  SUCCESS: 'fetchNotificationListSuccess',
  FAIL: 'fetchNotificationListFail',
};

export const GET_NOTIFICATION_COUNT = {
  LOADING: 'getNotificationCountLoading',
  SUCCESS: 'getNotificationCountSuccess',
  FAIL: 'getNotificationCountFail',
};

export const ACCEPT_SHARED_TRIP = {
  LOADING: 'acceptSharedTripLoading',
  SUCCESS: 'acceptSharedTripSuccess',
  FAIL: 'acceptSharedTripFail',
};

export const ACCEPT_ITINERARY = {
  LOADING: 'acceptItineraryLoading',
  SUCCESS: 'acceptItinerarySuccess',
  FAIL: 'acceptItineraryFail',
};
